import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M19.998 20.745a5.5 5.5 0 1 1 0-8.49 4.5 4.5 0 1 0 0 8.49M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#802000",
      fillRule: "evenodd",
      d: "M7.91 11s.04-.107-.01-.161-.246-.066-.193-.256c.04-.14.362-1.514.349-2.272-.025-1.35-.42-2.348-.42-2.348h-.131s.3 1.145.294 2.243c-.003.77-.303 1.578-.334 1.687-.076.263-.084.276-.202.52-.12.245-.215.354-.237.407A.8.8 0 0 0 7 11z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M7.256 3.498c-.078.226-.163.45-.159.684-.124.043-.252-.272-.372-.087.09.256.298.458.44.688.024.071.229.257.11.3-.299-.103-.371-.485-.556-.717-.216-.39-.617-.667-1.064-.686-.168.005-.714-.042-.572.249.21.143.467.237.674.398.154.015.433.274.416.372-.27-.11-.397-.243-.689-.36-.395-.154-.941-.061-1.16.335-.041.103-.101.403.027.432.15-.236.364-.5.682-.43.25.02-.278.47-.077.38.064-.03.212-.127.315-.137.102-.01.16.067.237.078.156.021.199.087.184.125-.017.045-.066.007-.224.057-.08.026-.12.096-.213.128a.7.7 0 0 1-.356.006c-.25-.11-.662-.091-.74.226 0 .14-.123-.015-.18.045-.043.153-.054.309-.277.295-.136.144-.275.293-.448.395.102.235.503-.235.484-.037-.175.241.09.292.206.106.197-.21.44-.465.733-.253.14.132.221-.07.322-.06.064.165.144.008.217-.038.118-.015.085.15.225.048.28-.187.625-.03.899-.212.291-.134.041.108-.04.202-.127.251-.016.58-.294.736-.112.299.132.693-.117.914-.036.138.32.123.42.18.174.007-.008-.404.165-.46.233.146.222-.26.174-.384.022-.284.038-.595.178-.852.149-.316.286.128.12.253-.095.29-.232.653-.017.923.062.014.113.165.193.212s.19-.012.21-.15c.102-.415.05-.862.197-1.266.104-.125.247-.02.312.095.205.241.35.543.6.742.226.107.427.27.532.505-.002.182.512.21.358.008-.147-.197-.05-.394.1-.525.08.02.055-.125-.007-.067-.1-.024-.107-.21.033-.121.234.076-.019-.172-.104-.18-.198-.124-.426-.267-.524-.482.259.002.527.143.79.056.212-.11.427.009.5.197.165-.026.095-.192 0-.247.12-.05.203-.153.058-.244-.076-.101.103-.273-.117-.266.007-.17-.06-.326-.243-.385-.184-.157-.723.232-.708-.122-.054-.193.22-.026.296-.122.079-.204-.377-.184-.226-.341.098-.064.558-.156.197-.224a.56.56 0 0 1-.477-.077c-.129.218-.498-.119-.432.27-.05.146-.38.526-.47.235.076-.229.467-.303.346-.61-.019-.193-.177.033-.25.018-.039-.12.113-.26.218-.289.21.163.216-.205.415-.175.146-.032-.047-.095-.087-.123.04-.108.263-.162.044-.256-.193-.144-.336.144-.496.16-.152-.175.14-.258.22-.35.004-.069-.17-.02-.118-.08.046-.083.354-.089.21-.212a1 1 0 0 0-.708.041c-.132.043-.17.344-.284.331-.053-.134.018-.398-.165-.436.01.187-.009.436-.086.638",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M25.13 8.946 24.834 8l-.297.946-.906-.352.536.828-.834.507.966.086-.133.985.668-.72.667.72-.133-.985.966-.086-.834-.507.536-.828zM20.834 13l.296.946.906-.352-.536.828.834.507-.966.086.133.985-.668-.72-.667.72.133-.985-.965-.086.833-.507-.536-.828.906.352zm4 8 .296.946.906-.352-.536.828.834.507-.966.087.133.984-.668-.72-.667.72.133-.985-.965-.086.833-.507-.536-.828.906.352zm5-9 .296.946.906-.352-.536.828.834.507-.966.086.133.985-.668-.72-.667.72.133-.985-.965-.086.833-.507-.536-.828.906.352zm-2.226 4.708L27.334 16l-.275.708-.726.056.556.493-.174.743.619-.403.617.403-.173-.743.556-.493z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCck = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCck_default = SvgFlagCck;

export { FlagCck_default as default };
